import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.active = false

        this.dot = this.$('dot')
    }

    init() {
        this.initTl()

        setInterval(() => {
            let rand = Math.random()

            if(rand < 0.2) {
                this.jump()
            }
        }, 500)

        this.jumpBind = this.jump.bind(this)
        this.el.addEventListener('mouseenter', this.jumpBind)
    }

    initTl() {
        let transform = {
            x: 0,
            y: 0,
            z: 0,
            sX: 1,
            sY: 1,
            sZ: 1
        }
        this.tl = new TimelineMax({
            repeat: 0,
            repeatDelay: 1,
            onUpdate: () => {
                TweenMax.set(this.dot, {
                    transform: `translate3d(${transform.x}px,${transform.y}px,${transform.z}px) scale3d(${transform.sX},${transform.sY},${transform.sZ})`
                })
            },
            onComplete: () => {
                this.active = false
            }
        })

        const TIME_UNIT = 1

        this.tl.fromTo(transform, TIME_UNIT*0.1, { sY: 1 }, { sY: 0.5, ease: Power2.easeInOut })
        this.tl.to(transform, TIME_UNIT*0.1, { sY: 2, ease: Power2.easeOut })

        this.tl.addLabel('pre')
        this.tl.to(transform, TIME_UNIT*.25, { y: -100, sY: 1, ease: Power2.easeOut }, 'pre')

        this.tl.addLabel('mid')
        this.tl.to(transform, TIME_UNIT*.25, { y: 0, sY: 2, ease: Power2.easeIn }, 'mid')
        this.tl.to(transform, TIME_UNIT*0.1, { sY: 0.5, ease: Power2.easeOut })

        this.tl.addLabel('post')
        this.tl.to(transform, TIME_UNIT*0.1, { sY: 1, ease: Power2.easeInOut }, 'post')
        this.tl.pause()

    }

    jump() {
        if(this.active) return

        this.active = true
        this.tl.progress(0)
        this.tl.play()
    }

    destroy() {
        this.el.removeEventListener('mouseenter', this.jumpBind)
    }
}
